"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdateReview = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _react = require("react");
var _constants = require("../constants");
var _ratingAndReviewDialogContext = require("../contexts/ratingAndReviewDialogContext");
var _resultContext = require("../contexts/resultContext");
var _hooks = require("../hooks");
const useUpdateReview = () => {
  const {
    customerId,
    isUserVerified
  } = (0, _auth.useToken)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const globalApiClient = (0, _globalApiClientReact.useApiClient)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    orderId,
    productCode: productCodeFromEvent,
    reviewId,
    onClose: onRatingAndReviewDialogClose,
    onSuccessUpdate
  } = (0, _ratingAndReviewDialogContext.useRatingAndReviewDialog)();
  const {
    onOpen: onResultDialogOpen
  } = (0, _resultContext.useResultDialog)();
  return (0, _react.useCallback)(formValues => {
    const {
      author,
      cons,
      productCode: productCodeFromForm,
      pros,
      reviewText,
      score
    } = formValues;
    const productCode = productCodeFromForm ?? productCodeFromEvent;
    if (!isUserVerified || !reviewId) {
      return;
    }
    (0, _globalApiClientReact.updateApplicationsCustomerFeedbackCustomerReview)(globalApiClient, String(customerId), reviewId, {
      author,
      cons: cons ?? [],
      pros: pros ?? [],
      reviewText,
      score: score ?? 1,
      reviewDate: new Date(),
      reviewState: _globalApiClientReact.GlobalCustomerFeedbackReviewDtoReviewState.AwaitingApproval,
      customerId: String(customerId),
      orderId,
      productCode
    }, {
      [_constants.ACCEPT_LANGUAGE]: language,
      [_fetching.TENANT_CONTEXT]: tenant
    }).then(() => {
      onResultDialogOpen({
        content: translations.reviewUpdateSuccessDescription,
        header: translations.reviewUpdateSuccessTitle,
        severity: 'success'
      });
      onSuccessUpdate?.();
    }).catch(() => {
      onResultDialogOpen({
        content: translations.reviewFailDescription,
        header: translations.reviewFailTitle,
        severity: 'error'
      });
    }).finally(() => {
      onRatingAndReviewDialogClose();
    });
  }, [customerId, globalApiClient, isUserVerified, language, onRatingAndReviewDialogClose, onResultDialogOpen, onSuccessUpdate, orderId, productCodeFromEvent, reviewId, tenant, translations.reviewFailDescription, translations.reviewFailTitle, translations.reviewUpdateSuccessDescription, translations.reviewUpdateSuccessTitle]);
};
exports.useUpdateReview = useUpdateReview;
